<template>
  <div id="app" class="container mx-auto">
    <div class="pic pic-ovl">
      <ul class="pic__ls fix-float row">
        <PicItem
          v-for="item, index in res"
          :key="index"
          :item="item"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import PicItem from './components/PicItem';

export default {
  name: 'App',
  components: {
    PicItem,
  },
  data(){
    return {
      res: [
        {
          "brand": "Donkey",
          "feature": "IG 爆紅熱銷，幸運繽紛招財貓！",
          "desc": "結合設計師的幽默感，讓生活充滿樂趣又不失品味。",
          "src": "http://img.udnfunlife.com/image/banner/20200814195020_s78736.jpg",
        },
        {
          "brand": "TROIKA",
          "feature": "德國精選文具/工具",
          "desc": "純粹的設計和巧妙的機械，適用於真正的科技粉，精緻的球形鎖定使操作簡單 - 使鑰匙圈易於進出",
          "src": "https://img.udnfunlife.com/image/banner/20200731172617_s38956.jpg",
        },
        {
          "brand": "O'PRECARE",
          "feature": "淨齒專家護理首選",
          "desc": "通過美國環保組織EWG對環境及健康友善的天然椰子油溫和起泡劑，故為全植物性來源成分的牙膏。",
          "src": "https://img.udnfunlife.com/image/banner/20200620232803_sp5155.jpg",
        },
        {
          "brand": "SPEXTRUM",
          "feature": "韓國設計雜貨",
          "desc": "強調兼具有趣及實用的產品發想。",
          "src": "https://img.udnfunlife.com/image/banner/20200731174509_s66271.jpg",
        },
        {
          "brand": "好日子",
          "feature": "環保食物袋",
          "desc": "從首支台灣設計的竹牙刷、蠶絲牙線、專為外帶飲食設計的Pockeat食物袋。",
          "src": "https://img.udnfunlife.com/image/banner/20200629150334_s83264.jpg",
        },
        {
          "brand": "Sagaform",
          "feature": "北歐餐廚設計",
          "desc": "瑞典知名的餐廚傢飾品牌，一系列產品皆與北歐最出色的設計師共同完成。",
          "src": "https://img.udnfunlife.com/image/banner/20200831183849_s52746.jpg",
        },
        {
          "brand": "NEOLAB",
          "feature": "智慧光學電子筆",
          "desc": "專為習慣於手寫、手繪的人而設計的智慧筆。",
          "src": "https://img.udnfunlife.com/image/banner/20200731174814_s41290.jpg",
        },
        {
          "brand": "ADAM",
          "feature": "科技生活選物",
          "desc": "以各種生活科技周邊，作為您與最新行動裝置之間的溝通橋樑。",
          "src": "https://img.udnfunlife.com/image/banner/20200731175943_s37938.jpg",
        },
      ],
    };
  },
}
</script>

<style>
*, *::before, *::after {
  box-sizing: border-box;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.container {
  width: 1200px;
}

.row {
  margin-left: -15px;
  margin-right: -15px;
}

.img-resp {
  width: 100%;
  height: auto;
  vertical-align: bottom;
}

.text-right {
  text-align: right;
}

.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fix-float::after {
  display: block;
  clear: both;
  content: '';
}

body {
  background-color: #eee;
  font-size: 15px;
  font-family: Arial, Helvetica, "LiHei Pro", "Microsoft JhengHei", MingLiU, sans-serif;
}

.pic__ls {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue